function BikeRetrieveSavedQuoteResponseTransformer($filter, jsonMapper, Util) {
    // transform functions
    var transformers = {
        camelcase: function(value) {
            if(value) {
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        },
        date: function(dateString) {
            var date = moment(dateString, 'YYYY-MM-DD') ;
            return date.format('DD/MM/YYYY') ;
        },
		today : function() {
			return moment().tz("Australia/Sydney").format('DD/MM/YYYY') ;
		},
        financeType: function(financeType) {
            switch(financeType) {
                case 'none':
                    return '';
                    break;
            }
        },
        convertGender: function(gender) {
            var gc = {
                M : 'male',
                F : 'female',
                I : 'intersex',
            };
            return gc[gender] ;
        },
        yesNo: function(value) {
            return value == 'yes' ? true : false;
        },
        checkbox: function(value) {
        },
        state: function(state) {
            if ( state )
                return state.replace('AU_', '');
        },
        coverType: function(coverType) {
            if(coverType === 'third_party' || coverType === 'third_party_fire_theft') {
                return 'third_party';
            }
            return coverType;
        },
        purchaseMonthFromMonthYear: function(monthYear) {
            if(monthYear){
                return monthYear.split('-')[1];
            }else{
                return '';
            }

        },
        purchaseYearFromMonthYear: function(monthYear) {
            if(monthYear){
                return monthYear.split('-')[0];
            }else{
                return '';
            }
        },
        thirdPartyPref: function(coverType) {
            if(coverType === 'comprehensive') {
                return null;
            }
            return coverType;
        },
		modifications: function(mod) {
			if (!!mod) {
				var values = [{"label":"Big bore kit","value":"big_bore_kit"},{"label":"Cam modified","value":"cam_modified"},{"label":"Custom paint","value":"custom_paint"},{"label":"Frame – non standard","value":"frame_non_standard"},{"label":"Modified exhaust","value":"modified_exhaust"},{"label":"Modified or non-standard engine","value":"modified_or_non-standard_engine"},{"label":"Modified or non-standard fuel system","value":"modified_or_non-standard_fuel_system"},{"label":"Modified suspension","value":"modified_suspension"},{"label":"Nitrous oxide","value":"nitrous_oxide"},{"label":"Other modifications and customisations","value":"other_modifications_and_customisations"},{"label":"Side car","value":"side_car"},{"label":"Supercharged","value":"supercharged"},{"label":"Turbo charged","value":"turbo_charged"},{"label":"Wheels – non standard","value":"wheels_non_standard"}];
				return values.find(function(o) {
					return o.value === mod;
				}).label;
			}
		},
		accessories: function(accessory) {
			if (!!accessory) {
				var values = [{"label":"Aftermarket levers (brake and clutch)","value":"Aftermarketleversbrakeandclutch"},{"label":"Air filter","value":"Airfilter"},{"label":"Bash plate","value":"Bashplate"},{"label":"Braided brake lines","value":"Braidedbrakelines"},{"label":"Brake discs","value":"Brakediscs"},{"label":"Burglar alarm","value":"Burglaralarm"},{"label":"Carbon fibre guards","value":"Carbonfibreguards"},{"label":"Centre stand","value":"Centrestand"},{"label":"Crash bars","value":"Crashbars"},{"label":"Fender eliminator","value":"Fendereliminator"},{"label":"Foot pegs","value":"Footpegs"},{"label":"Forward controls","value":"Forwardcontrols"},{"label":"GPS","value":"GPS"},{"label":"Gear shift lever","value":"Gearshiftlever"},{"label":"Hand guards","value":"Handguards"},{"label":"Hand Grips","value":"HandGrips"},{"label":"Handlebars","value":"Handlebars"},{"label":"Headlight Protectors","value":"HeadlightProtectors"},{"label":"Immobiliser","value":"Immobiliser"},{"label":"Indicators","value":"Indicators"},{"label":"Instrument clusters","value":"Instrumentclusters"},{"label":"Intercom system","value":"Intercomsystem"},{"label":"Kill switch","value":"Killswitch"},{"label":"Lights","value":"Lights"},{"label":"Mirrors","value":"Mirrors"},{"label":"Motorcycle rack","value":"Motorcyclerack"},{"label":"Oggy knobs","value":"Oggyknobs"},{"label":"On road costs","value":"Onroadcosts"},{"label":"Panniers","value":"Panniers"},{"label":"Power commander","value":"Powercommander"},{"label":"Radiator guard","value":"Radiatorguard"},{"label":"Rear hugger","value":"Rearhugger"},{"label":"Saddle bags","value":"Saddlebags"},{"label":"Seat sissy bar","value":"Seatsissybar"},{"label":"Steering damper","value":"Steeringdamper"},{"label":"Stereo","value":"Stereo"},{"label":"Tank bag","value":"Tankbag"},{"label":"Tank pad","value":"Tankpad"},{"label":"Tank protector","value":"Tankprotector"},{"label":"Top Box","value":"TopBox"},{"label":"Windshield","value":"Windshield"},{"label":"Other non-standard accessories","value":"Othernon-standardaccessories"}];
				return values.find(function(o) {
					return o.value === accessory;
				}).label;
			}
		},
		yearsHeld: function(years) {
			var yearsHeld;

			switch (years) {
				case '0':
					yearsHeld = 'lessThan_1';
					break;
				case '6':
					yearsHeld = 'greaterThan_5';
					break;
				default:
					yearsHeld = years;
			}

			return yearsHeld;
		},
    };
    function transformPerson(person) {
        var transformMapping = {
                'returnObject.title':                                   '=_input.prefix',
                'returnObject.firstName':                               '=_input.firstName',
                'returnObject.lastName':                                '=_input.lastName',
                'returnObject.gender':                                  '=_input.gender',
                'returnObject.dateOfBirth':                             '=_input.dateOfBirth'
            },
            convertMapping = {
                'returnObject.title':                                   transformers.camelcase,
                'returnObject.gender':                                  transformers.convertGender,
                'returnObject.dateOfBirth':                             transformers.date
            };
        var transformedPerson = jsonMapper.convert(jsonMapper.transform(person, transformMapping), convertMapping);
        return transformedPerson.returnObject;
    }

    function transformRider(rider) {
        var transformMapping = {
        	'returnObject.yearsHeld':                                       		'=_input.rider.yearsLicenced',
            'returnObject.licenceType':                                     		'=_input.rider.licenceType',
            'returnObject.noClaimBonus':                                    		'=_input.rider.noClaimBonus',
            'returnObject.previousInsurer':                                 		'=_input.rider.currentInsurer',
            'returnObject.licensedToRide':                                  		'=_input.licensedToRide',
			'returnObject.threeYears_accidentsClaims': 								'=_input.rider.hasClaim',
			'returnObject.fiveYears_chargedOrConvicted': 							'=_input.rider.hasConviction',
			'returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled': 	'=_input.rider.hasLostLicence',
			'returnObject.visaType':											 	'=_input.rider.visaType',
            },
            convertMapping = {
				'returnObject.yearsHeld':                                   		transformers.yearsHeld,
                'returnObject.licensedToRide':                              		transformers.yesNo,
				'returnObject.threeYears_accidentsClaims': 							transformers.yesNo,
				'returnObject.fiveYears_chargedOrConvicted': 						transformers.yesNo,
				'returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled':	transformers.yesNo
            };

		var mappedRider = jsonMapper.transform(rider, transformMapping);
        var transformedRider = jsonMapper.convert(mappedRider, convertMapping);
        if(rider.rider.person) {
            transformedRider.returnObject.person = transformPerson(rider.rider.person);
        }

        // extract rider history
		transformedRider.returnObject.threeYears_accidentsClaimsDetails = [];
		transformedRider.returnObject.fiveYears_chargedOrConvictedDetails = [];
		transformedRider.returnObject.threeYears_restrictedSuspendedDisqualifiedCancelledDetails = [];

		if (!!rider.rider.riderHistory) {
			rider.rider.riderHistory.forEach(function(record) {
				switch (record.pattern.filter1) {
					case 'claim' :
						transformedRider.returnObject.threeYears_accidentsClaimsDetails.push(
							extractHistory(globals.threeYears_accidentsClaimsDetails.options, record));
						break;
					case 'conviction' :
						transformedRider.returnObject.fiveYears_chargedOrConvictedDetails.push(
							extractHistory(globals.fiveYears_chargedOrConvictedDetails.options, record)
						);
						break;
					default: {
						transformedRider.returnObject.threeYears_restrictedSuspendedDisqualifiedCancelledDetails.push(
							extractHistory(globals.threeYears_restrictedSuspendedDisqualifiedCancelledDetails.options, record)
						);
						break;
					}
				}
			});
		}
        return transformedRider.returnObject;
    }

    function extractHistory(collection, record) {
		var matchedPattern = {};
		var month = {};
		var year = {};

		matchedPattern = collection.find(function(opt) {
			return opt.publicID == record.pattern.publicID;
		});
		month.label = month.value = Util.capitalize(record.month.toString());
		year.label = year.value = Util.capitalize(record.year.toString());

		record.description = matchedPattern;
		record.month = month;
		record.year = year;

		delete record.pattern;

    	return record;
	}

	function extractPolicyHolderHistory(collection, record) {
		var matchedPattern = {};
		var month = {};
		var year = {};

		matchedPattern = collection.find(function(opt) {
			return opt.publicID = record.riderPattern.publicID;
		});
		month.label = month.value = Util.capitalize(record.riderMonth.toString());
		year.label = year.value = Util.capitalize(record.year.toString());

		record.description = matchedPattern;
		record.month = month;
		record.year = year;

		delete record.pattern;

    	return record;
	}

    function transformPolicyHolder(holder) {
        var transformMapping = {
			'returnObject.title':                                           		'=_input.prefix',
			'returnObject.firstName':                                       		'=_input.firstName',
			'returnObject.lastName':                                        		'=_input.lastName',
			'returnObject.gender':                                          		'=_input.gender',
			'returnObject.dateOfBirth':                                     		'=_input.dateOfBirth',
			// 'returnObject.threeYears_accidentsClaims': 								'=_input.rider.hasClaim',
			// 'returnObject.fiveYears_chargedOrConvicted': 							'=_input.rider.hasConviction',
			// 'returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled': 	'=_input.rider.hasLostLicence',
		},
		convertMapping = {
			'returnObject.title':                                       		transformers.camelcase,
			'returnObject.gender':                                      		transformers.convertGender,
			'returnObject.dateOfBirth':                                 		transformers.date,
			// 'returnObject.threeYears_accidentsClaims': 							transformers.yesNo,
			// 'returnObject.fiveYears_chargedOrConvicted': 						transformers.yesNo,
			// 'returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled':	transformers.yesNo
		};

        var transformedPolicyHolder = jsonMapper.convert(jsonMapper.transform(holder, transformMapping), convertMapping);

		//region Policy Holder driving history
		transformedPolicyHolder.returnObject.threeYears_accidentsClaims = false;
		transformedPolicyHolder.returnObject.threeYears_accidentsClaimsDetails = [];
		transformedPolicyHolder.returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled = false;
		transformedPolicyHolder.returnObject.threeYears_restrictedSuspendedDisqualifiedCancelledDetails = [];
		transformedPolicyHolder.returnObject.fiveYears_chargedOrConvicted = false;
		transformedPolicyHolder.returnObject.fiveYears_chargedOrConvictedDetails = [];

		if (!!holder.drivingHistory) {
			holder.drivingHistory.forEach(function(record) {
				switch(record.riderPattern.filter1) {
					case 'claim' :
						transformedPolicyHolder.returnObject.threeYears_accidentsClaims = true;
						transformedPolicyHolder.returnObject.threeYears_accidentsClaimsDetails.push(
							extractPolicyHolderHistory(globals.threeYears_accidentsClaimsDetails.options, record));
						break;
					case 'conviction' :
						transformedPolicyHolder.returnObject.fiveYears_chargedOrConvicted = true;
						transformedPolicyHolder.returnObject.fiveYears_chargedOrConvictedDetails.push(
							extractPolicyHolderHistory(globals.fiveYears_chargedOrConvictedDetails.options, record)
						);
						break;
					default: {
						transformedPolicyHolder.returnObject.threeYears_restrictedSuspendedDisqualifiedCancelled = true;
						transformedPolicyHolder.returnObject.threeYears_restrictedSuspendedDisqualifiedCancelledDetails.push(
							extractPolicyHolderHistory(globals.threeYears_restrictedSuspendedDisqualifiedCancelledDetails.options, record)
						);
						break;
					}
				}
			});
		}
		// endregion

        return transformedPolicyHolder.returnObject;
    }

    /**
     * Transforms the retrievedQuoteResponse into a format that can be injected into the userInputRepository
     * The returned value will populate all the forms in the quote process
     * @param {Object} retrievedQuoteResponse                   Response object from the retrieveSavedQuote service
     * @returns {Object}                                        Transformed object ready to inject into the userInputRepository
     */
    function transform(retrievedQuoteResponse) {
    	console.info('retrievedQuoteResponse', JSON.stringify(retrievedQuoteResponse));
    	console.info('retrievedQuoteResponse', retrievedQuoteResponse);
        var transformMapping = {
				// getStarted
				// 'vehicleForm.getStarted.paymentOptions':         '=_input.?',
				'returnObject.getStarted.policyStartDate':
					'=_input.periodStartDate', // find where this comes from
				'returnObject.getStarted.personOrCompany':
					'=_input.policyHolders.0.contact.contactType',

				//tell us a bit more -------------------------------------
				'returnObject.tellUsABitMore.yourEmailAddress': '=_input.email',
				'returnObject.tellUsABitMore.promotionalCode':
					'=_input.campaignCode',

				// aboutYourBike
				'returnObject.address': '=_input.motorcycles.0.accountLocation',
				'returnObject.motorcycleInfo':
					'=_input.motorcycles.0.motorcycleInfo',
				'returnObject.aboutYourBike.purchaseDate':
					'=_input.motorcycles.0.purchaseDate',
				'returnObject.aboutYourBike.bikeCost':
					'=_input.motorcycles.0.purchasePrice',

				// Modifications and Accessories
				'returnObject.modificationsAccessories.modifications':
					'=_input.motorcycles.0.isBikeModified',
				'returnObject.modificationsAccessories.accessories':
					'=_input.motorcycles.0.isAccessoriesAdded',

				// Bike Details
				'returnObject.bikeDetails.locationParked':
					'=_input.motorcycles.0.garageType',
				'returnObject.bikeDetails.isItFinanced':
					'=_input.motorcycles.0.isFinanced',
				'returnObject.bikeDetails.financeWith':
					'=_input.motorcycles.0.financier',
				'returnObject.bikeDetails.kilometres':
					'=_input.motorcycles.0.motorCycleKilometers',
				'returnObject.bikeDetails.primaryBikeUse':
					'=_input.motorcycles.0.motorCycleUsage',
				'returnObject.bikeDetails.businessActivityType':
					'=_input.motorcycles.0.businessUsage',
				'returnObject.bikeDetails.commercialActivityType':
					'=_input.motorcycles.0.businessUsage',
				'returnObject.bikeDetails.existingDamage':
					'=_input.motorcycles.0.damage',

				//driver
				// 'vehicleForm.driver.paymentOptions':             '=_input.?',

				//quote
				// 'returnObject.insuredExcessValue.coverType':                            '=_input.vehicles.0.coverType',
				// 'returnObject.insuredExcessValue.comprehensivePref':                    '=_input.vehicles.0.sumInsuredType',
				// 'returnObject.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft':   '=_input.vehicles.0.coverType',
				// 'returnObject.insuredExcessValue.vehicleExcess':                        '=_input.vehicles.0.excess.voluntaryVehicleExcessOptions',
				// 'returnObject.insuredExcessValue.standardVehicleExcess':                '=_input.vehicles.0.excess.standardVehicleExcess',
				// 'returnObject.insuredExcessValue.voluntaryVehicleExcess':               '=_input.vehicles.0.excess.voluntaryVehicleExcess',
				// 'returnObject.insuredExcessValue.ageExcessTier1':                       '=_input.vehicles.0.excess.ageExcessTier1',
				// 'returnObject.insuredExcessValue.ageExcessTier2':                       '=_input.vehicles.0.excess.ageExcessTier2',
				// 'returnObject.insuredExcessValue.undeclaredDriverTier2':                '=_input.vehicles.0.excess.undeclaredDriverTier2',
				// 'returnObject.insuredExcessValue.inexperiencedDriver':                  '=_input.vehicles.0.excess.inexperiencedDriver',
				// 'returnObject.insuredExcessValue.agreedValue':                          '=_input.vehicles.0.sumInsuredAmount',

				// optional benefits
				// 'returnObject.optionalBenefits.QPMMotVehHireCar':                   '=_input.vehicles.0.coverageOptions.0.selected',
				// 'returnObject.optionalBenefits.QPMMotVehWindscreen':                '=_input.vehicles.0.coverageOptions.1.selected',
				// 'returnObject.optionalBenefits.QPMMotVehNCB':                       '=_input.vehicles.0.coverageOptions.2.selected',

				// registration details
				'returnObject.tellUsYourRegoNumber.regoNumber':
					'=_input.motorcycles.0.registrationNumber',
				// 'returnObject.vehicleInfo':     			        '=_input.vehicles.0.vehicleInfo',
				// 'returnObject.retrievedQuoteRego.rego':             '=_input.vehicles.0.registrationNumber',
				// 'returnObject.retrievedQuoteRego.state':            '=_input.vehicles.0.garageAddress.state'
				// Contact
				'returnObject.mainPolicyHolderContact.passwordQuestion':
					'=_input.policyHolders.0.contact.passwordQuestion',
				'returnObject.mainPolicyHolderContact.passwordAnswer':
					'=_input.policyHolders.0.contact.passwordAnswer',
				'returnObject.mainPolicyHolderContact.primaryPhone':
					'=_input.policyHolders.0.contact.primaryPhone'
			},
			convertMapping = {
				'returnObject.aboutYourBike.purchaseDate': transformers.date,
				'returnObject.bikeDetails.isItFinanced': transformers.yesNo,
				'returnObject.getStarted.policyStartDate': transformers.date
				// 'returnObject.rider.isTheMainRider':									transformers.yesNo,
				// 'returnObject.rider.isMemberOfClub':									transformers.yesNo

				// 'returnObject.carDetails.colour':                                       transformers.camelcase,
				// 'returnObject.carDetails.carFinance':                        			transformers.financeType,
				// 'returnObject.retrievedQuoteRego.state':                                transformers.state,
				// 'returnObject.insuredExcessValue.coverType':                            transformers.coverType,
				// 'returnObject.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft':   transformers.thirdPartyPref,
				// 'returnObject.carDetails.whenDidYouBuyYear':                            transformers.purchaseMonthFromMonthYear,
				// 'returnObject.carDetails.whenDidYouBuyMonth':                           transformers.purchaseYearFromMonthYear
			};
        var transformedQuote = jsonMapper.convert(jsonMapper.transform(retrievedQuoteResponse, transformMapping), convertMapping);

        // region set comprehensive preference to null if the coverType is third party
        /*if(retrievedQuoteResponse.motorcycles[0].coverType.length && retrievedQuoteResponse.motorcycles[0].sumInsuredType.length) {
            var coverType = retrievedQuoteResponse.motorcycles[0].coverType;
            if(coverType === 'third_party' || coverType === 'third_party_fire_theft') {
                transformedQuote.returnObject.insuredExcessValue.comprehensivePref = null;
            }
        }*/
		// endregion

        // region Mods and Accessories
		if (retrievedQuoteResponse.motorcycles[0].qpyCycleModifications) {
			var mods = retrievedQuoteResponse.motorcycles[0].qpyCycleModifications;

			transformedQuote.returnObject.modificationsAccessories.modificationsTable = mods.map(function(mod) {
				return {
					'modification' : {
							'label' : transformers.modifications(mod.modification),
							'value' : mod.modification
					},
					'modificationValue' : mod.purchasePrice
				}
			});
		}
		if (retrievedQuoteResponse.motorcycles[0].qpyMotorcycleAccessories) {
			var acc = retrievedQuoteResponse.motorcycles[0].qpyMotorcycleAccessories;

			transformedQuote.returnObject.modificationsAccessories.accessoriesTable = acc.map(function(accessory) {
				return {
					'accessories' : {
						'label' : transformers.accessories(accessory.accessory),
						'value' : accessory.accessory
					},
					'accessoryValue' : accessory.purchasePrice
				}
			});
		}
		// endregion

        // region Sort drivers to put mainRider first in the list
        if(retrievedQuoteResponse.motorcycles && retrievedQuoteResponse.motorcycles.length && retrievedQuoteResponse.motorcycles[0].riders) {
            var riders = $filter('orderBy')(retrievedQuoteResponse.motorcycles[0].riders, function(rider) {
                return rider.riderUsage == 'main' ? 0 : 1;
            });
            transformedQuote.returnObject.rider = {};
            transformedQuote.returnObject.rider.riders = [];
            riders.forEach(function(rider, index) {
                transformedQuote.returnObject.rider.riders.push(transformRider(rider));

				if (index === 0) {
					// License and insurance details
					transformedQuote.returnObject.rider.riders[0].isTheMainRider = retrievedQuoteResponse.motorcycles[0].isTheMainRider;
					transformedQuote.returnObject.rider.riders[0].isMemberOfClub = retrievedQuoteResponse.motorcycles[0].isMemberOfClub;
					transformedQuote.returnObject.rider.riders[0].motorcycleClub = retrievedQuoteResponse.motorcycles[0].motorcycleClub;
				}
            });
        }
        // endregion

        // region set contact policy holders
        if(!!retrievedQuoteResponse.policyHolders && !!retrievedQuoteResponse.policyHolders.length) {
            var policyHolders = retrievedQuoteResponse.policyHolders;
			var response = retrievedQuoteResponse;

            transformedQuote.returnObject.mainPolicyHolder = {};

            policyHolders.forEach(function(holder, index) {
                if(holder.mainHolder) {
                    transformedQuote.returnObject.mainPolicyHolder = transformPolicyHolder(holder.contact);
                    transformedQuote.returnObject.mainPolicyHolder.isMainRiderMainPolicyHolder = true;

					transformedQuote.returnObject.mainPolicyHolderContact = holder.contact;
					transformedQuote.returnObject.mainPolicyHolderContact
						.personalContactDetailsMailingPreference = response.documentDeliveryMethod;
					
					// if (transformedQuote.returnObject.mainPolicyHolderContact.returnObject !== undefined
					// 	&& transformedQuote.returnObject.mainPolicyHolderContact.returnObject.dateOfBirth) {
					// 		transformedQuote.returnObject.mainPolicyHolderContact.returnObject.dateOfBirth =
					// 			transformers.date(transformedQuote.returnObject.mainPolicyHolderContact.returnObject.dateOfBirth);
					// }

						// set primary phone number to mobile phone
					if(response.policyHolders[0].contact.cellPhone) {
						transformedQuote.returnObject.mainPolicyHolderContact.primaryPhoneNumber = response.policyHolders[0].contact.cellPhone;
					}

					// set primary phone number to home phone
					if(response.policyHolders[0].contact.homePhone) {
						transformedQuote.returnObject.mainPolicyHolderContact.primaryPhoneNumber = response.policyHolders[0].contact.homePhone;
					}

					// set primary phone number to work phone
					if(response.policyHolders[0].contact.workPhone) {
						transformedQuote.returnObject.mainPolicyHolderContact.primaryPhoneNumber = response.policyHolders[0].contact.workPhone;
					}	
					
					if (holder.contact.contactType === 'company') {
						transformedQuote.returnObject.aboutCompany = {};
						transformedQuote.returnObject.aboutCompany.name = holder.contact.name;
						transformedQuote.returnObject.aboutCompany.abn = holder.contact.abn;
						transformedQuote.returnObject.aboutCompany.email = holder.contact.emailAddress1;
						transformedQuote.returnObject.aboutCompany.officePhone = holder.contact.workPhone;
						transformedQuote.returnObject.aboutCompany.companyAddress = holder.contact.primaryAddress;

						transformedQuote.returnObject.companyContact = {};
						var authorisedPerson = holder.contact.authorisedPersons[0].person;

						if (response.policyAddress.addressLine1 === authorisedPerson.primaryAddress.addressLine1 &&
							response.policyAddress.postalCode === authorisedPerson.primaryAddress.postalCode) {
							transformedQuote.returnObject.companyContact.companyContactDetailsPostalOption = true;
						}
						else {
							transformedQuote.returnObject.companyContact.companyContactDetailsPostalOption = false;
						}
						transformedQuote.returnObject.companyContact.companyContactTitle = authorisedPerson.prefix;
						transformedQuote.returnObject.companyContact.companyContactFirstName = authorisedPerson.firstName;
						transformedQuote.returnObject.companyContact.companyContactLastName = authorisedPerson.lastName;
						transformedQuote.returnObject.companyContact.companyContactGender = authorisedPerson.gender;
						transformedQuote.returnObject.companyContact.companyContactDateOfBirth = transformers.date(authorisedPerson.dateOfBirth);
						transformedQuote.returnObject.companyContact.companyContactDetailsAddress = authorisedPerson.primaryAddress;
						transformedQuote.returnObject.companyContact.companyContactDetailsEmail = authorisedPerson.emailAddress1;
						transformedQuote.returnObject.companyContact.companyContactDetailsPostalAddress = response.policyAddress;
						transformedQuote.returnObject.companyContact.companyContactDetailsMailingPreference =
							response.documentDeliveryMethod;
						transformedQuote.returnObject.companyContact.primaryPhone = authorisedPerson.primaryPhone;
						transformedQuote.returnObject.companyContact.preferredNumber = authorisedPerson.homePhone || authorisedPerson.workPhone || authorisedPerson.cellPhone;
						transformedQuote.returnObject.companyContact.passwordQuestion = holder.contact.passwordQuestion;
						transformedQuote.returnObject.companyContact.enterAQuestion = holder.contact.passwordQuestionStr || '';
						transformedQuote.returnObject.companyContact.passwordAnswer = holder.contact.passwordAnswer;
					}
                } else {
					if (index === 1) {
						transformedQuote.returnObject.additionalPolicyHolders = {};
						transformedQuote.returnObject.additionalPolicyHolders.policyHolders = [];
					}
					transformedQuote.returnObject.additionalPolicyHolders.policyHolders.push(transformPolicyHolder(holder.contact));
                }
            });

        }
        // endregion

        console.info('final transform quote', JSON.stringify(transformedQuote.returnObject));
        console.info('final transform quote', transformedQuote.returnObject);

        return transformedQuote.returnObject;
    }
    return {
        transform: transform
    }
}
